/*
 * @Author: jingfei
 * @Date: 2021-09-14 19:04:39
 * @LastEditTime: 2021-09-28 20:04:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \scim-edm-web\src\api\excel.js
 */
import request from "@/utils/request";
const excelExportRequestUrl = `${window.env.scimSystem}/api/v1/dict`;
const excelImportRequestUrl = `${window.env.scimSystem}/api/v1`;
const { basicService } = window.env;

const api = {
  // 导出
  exportExcel(params) {
    return request({
      url: `${excelExportRequestUrl}/export-dict`,
      method: "get",
      responseType: "blob",
      params
    });
  },
  // 附件下载
  downloadAttachment(id) {
    return request({
      url: `${excelImportRequestUrl}/attachment/download/${id}`,
      method: "get",
      responseType: "blob"
    });
  },
  // 导入
  importExcel(data, templateCode) {
    return request({
      url: `${excelImportRequestUrl}/excel/template/${templateCode}/import`,
      method: "post",
      data
    });
  },
  importExcelRecord(params) {
    return request({
      url: `${excelImportRequestUrl}/excel/record/page`,
      method: "get",
      params
    });
  },
  // scim-edm-base服务  excel导入
  importExcelOfBase(data, templateCode) {
    return request({
      url: `${basicService}/api/v1/excel/template/${templateCode}/import`,
      method: "post",
      data
    });
  },
  // 根据编码查询模板配置
  getAttachmentId(templateCode) {
    return request({
      url: `${excelImportRequestUrl}/excel/template/code/${templateCode}/type/IMPORT`,
      method: "get"
    });
  }
};
export default api;
